module.exports = __webpack_public_path__ + "img/google-play.b3fb1a1b.svg";